import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const updateContentMarkedForDeletionAllReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<{ action: 'add' | 'remove'; ids?: Array<string | number> }>) => {
    if (action.payload.action === 'add' && action.payload.ids) {
      const addedIds = action.payload.ids.reduce(
        (acc, id) => {
          acc[id] = true;
          return acc;
        },
        {} as Record<string | number, boolean>
      );
      state.contentMarkedForDeletion = { ...state.contentMarkedForDeletion, ...addedIds };
    } else {
      state.contentMarkedForDeletion = {};
    }
  });
};

export default updateContentMarkedForDeletionAllReducer;
